type RoleLike = { slug: string }

/**
 * The role a task runs as, as the API resolves it: the company's one role of that name. A role is a job across the
 * company, held by members on any team, and a task belongs to it, not to a team: any holder may take a run. Undefined
 * for a task with no role, or a name no role has.
 */
export function runsAsRole<R extends RoleLike>(task: { assigneeRole?: string | null }, roles: R[]): R | undefined {
    if (!task.assigneeRole) {
        return undefined
    }
    return roles.find(role => role.slug === task.assigneeRole)
}

/**
 * The roles a task can be assigned: every role the company has, since a role is held across teams. Each run then goes
 * to a holder of it, on whatever team they sit.
 */
export function assignableRoles<R extends RoleLike>(roles: R[]): R[] {
    return roles
}
